<template>
  <div class="tab-content">
    <!-- 文件展示表格 -->
    <el-card style="margin-top:10px; ">
      <el-table
          ref="fileTable"
          :data="commonObjList"
          :key="tableKey"
          style="width: 100%; margin: auto"
          @selection-change="handleSelectionChange"
          v-loading="loading"
          :header-cell-style="{ color: 'black' }"
          :height="tableHeight"
      >
        <!-- 选择框 -->
<!--        <el-table-column-->
<!--            type="selection"-->
<!--            width="55"-->
<!--            align="center"-->
<!--            :selectable="rowSelectable"-->
<!--        />-->

        <!-- 文件名称 -->
        <el-table-column
            prop="name"
            label="文件名"
            width="180"
        />

        <!-- 内容类型-->
<!--        <el-table-column-->
<!--            label="文件标签"-->
<!--            prop="labels"-->
<!--            width="180"-->
<!--            align="left">-->

<!--        </el-table-column>-->

        <!-- 文件格式 -->
        <el-table-column
            prop="file_type"
            align="center"
            label="文件格式"
            width="100"
        />

        <!-- 文件大小 -->
        <el-table-column
            prop="file_size"
            align="center"
            label="文件大小"
            width="100"
            :formatter="formatSize"
        />

        <el-table-column label="文件路径" width="120">
          <template #default="{ row }">
            <div
                class="file-path-hover"
                @click="openFile(row.file_path)"
                :style="{ cursor: row.file_path ? 'pointer' : 'default' }"
                v-if="row.file_path"
            >
              {{ row.file_path}}
            </div>
            <div v-else> - </div>
          </template>
        </el-table-column>
<!--        <el-table-column label="分析结果" align="center" prop="file_pre_analyse" show-overflow-tooltip>-->
<!--        </el-table-column>-->
        <el-table-column label="缩略图" width="180">
          <template #default="{ row }">
            <el-image v-if="row.file_image_keys" :src="row.file_image_keys[0]" alt="缩略图" :preview-src-list="row.file_image_keys"
                      style="width: auto; height: 50px;"/>
            <!--            <span v-else style="color: grey; font-weight: bold; font-size: 13px">无缩略图</span>-->
          </template>
        </el-table-column>

        <el-table-column label="文件状态" align="center" prop="status" width="120">
          <template v-slot="scope">

            <span  style="font-size: 13px">{{scope.row.status}}</span>

          </template>
        </el-table-column>

        <el-table-column label="未提取原因" align="center" prop="status" width="120">
          <template v-slot="scope">

            <span  style="font-size: 13px">{{scope.row.status}}</span>

          </template>
        </el-table-column>

        <el-table-column label="解析状态/操作" align="center" width="180">
          <template v-slot="scope">
            <span v-if="scope.row.status_code >= 399 "
                  style="color: green; font-weight: bold; font-size: 13px ">解析完成</span>
            <span v-else-if="scope.row.status_code > 100" style="font-size: 13px">解析中...</span>
            <el-button
                v-else-if="scope.row.status_code < -100"
                type="danger"
                link
                size="small"
                @click="handleReParse(scope.row)"
            >
              重新解析
            </el-button>
            <el-button size="small" link @click="openFile(scope['file_path'])">
              打开源文档
            </el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-card>


    <!-- 操作按钮 -->
  </div>
</template>

<script>
import {ElMessage} from 'element-plus';

import {
  getThumbnailByElectronFileInfo
} from "@/components/file_process_js/ function_process/file_info";
import {mapState} from "vuex";
import {fileReProcess} from "@/components/file_process_js/main_process";


// 普通文件和其他层不一样，其他层参数只会出现一次，而普通文件中出现的参数次数是不可控的，需要以文件为维度收集
// 先加载匹配模板，将 远程服务匹配到的值绑定文件保存
export default {
  data() {
    return {
      commonObjList: [],

      loading: false, // 显示加载中的状态
      selectFilePathMap: {}, // 用于传递最终选择状态
      curSelectFilePathMap: {}, // 用于储存当前选择状态

      historyMode: false,

      tableHeight: "auto",
      tableKey:0,
    };
  },

  emits: ["startParse", "changeComponent"],

  computed: {
    ...mapState(['statusChangeSign']),
  },
  watch: {
    statusChangeSign(currentSign) {
      if (currentSign > 0) {
        this.tableKey = currentSign;
      }
    }
  },

  methods: {

    refreshFileList() {
      // 普通文件和gerber文件统一处理
      const tempList = this.$store.state.commonObjList.concat(this.$store.state.gerberObjList)
      // this.commonObjList = this.$store.state.commonObjList
      this.commonObjList = tempList.filter(item => {
        return item.status_code < 399
      })
      this.getAllFileThumbnail();
    },

    rowSelectable(row) {
      return !this.historyMode; // 如果是historyMode，禁用勾选框
    },

    getAllFileThumbnail() {
      this.commonObjList.map(obj => {
        if (!obj.thumbnail) {
          // getThumbnailByElectronFileInfo(obj).then(url => {
          //   obj['thumbnail'] = url;
          // })
        }
      })
    },

    async addFile() {
      const newFileList = await this.triggerFileSelect();
      for (const fileAbsPath of newFileList) {
        const existFile = this.commonObjList.find(s => s.file_path === fileAbsPath);
        if (existFile) {
          ElMessage.warning(`文件：${fileAbsPath}已添加，请勿重复添加。`);
          continue
        }
        await this.$store.dispatch("syncProjectFile", {filePath:fileAbsPath, mode:"add"});
        this.refreshFileList();
      }
    },

    handleSelectionChange(selectedRows) {
      this.commonObjList.map(fileInfo => {
        let tempSelect = false
        for (let i = 0; i < selectedRows.length; i++) {
          if (selectedRows[i]['file_path'] === fileInfo['file_path']) {
            tempSelect = true
            break;
          }
        }
        fileInfo.select = tempSelect
      })
      console.log("handleSelectionChange commonObjList", this.commonObjList);
    },

    async go_to_next() {
      this.$store.commit("setSelectFilePathMap", this.selectFilePathMap);
      this.$emit('changeComponent', 1);
      this.$store.commit("addCommonFileChangeSign")
    },


    async triggerFileSelect() {
      return await window.electronAPI.selectFile('file');
    },

    formatSize(row, column, cellValue) {
      if (cellValue == null) return '--';
      return (cellValue / 1024).toFixed(2) + ' KB';
    },



    async runHistoryMode() {
    },

    openFile(filePath) {
      window.electronAPI.openFile(filePath);
    },

    handleReParse(fileInfo) {
      fileReProcess(fileInfo)
    }
  },

  mounted() {
    // this.updateTableHeight();
    this.historyMode = this.$route.query.history;

    if (this.historyMode) {
      this.runHistoryMode()
    } else {
      this.refreshFileList(); // 组件加载时获取文件列表
    }

  },
};
</script>

<style>
.el-table__cell {
  position: static !important;
}

.file-path {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  direction: rtl; /* 从右向左展示内容 */
  text-align: left; /* 保持内容左对齐 */
}

.button-container {
  margin-top: 20px;
  text-align: right; /* 按钮右对齐 */
}
</style>
